import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import './knowledge.css';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { apiService } from '../../services/apiService';
import Select from 'react-select';
import { toast } from 'react-toastify';
function KbAssignments() {
    const location = useLocation();
    const currentPath = location.pathname;
    const navigate = useNavigate();
    const { id } = useParams();
    const [catesNames,setCateNames] = useState('');
    const [loading, setLoading] = useState(true);
    const [articleDetail, setArticleDetail] = useState([]);
    // const author_ids = Number(localStorage.getItem('userid'));
    // const [authorDetail,setAuthorDetail] = useState('');
    // const isAuthor = (authorDetail && authorDetail.id === author_ids && articleDetail.status === "draft");
    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState('');
    const [groupId, setGroupId] = useState([]);
    const [userId, setUserId] = useState([]);
    const [selectedGroupId, setSelectedGroupId] = useState(null);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [formData, setFormData] = useState({
        assignment_group_id: '',
        assigned_to: '',
        reason: '',
    });
    useEffect(() => {
        const fetchPreviewData = async () => {
            try {
                const response = await apiService.getRequest(`knowledge-article/${id}`);
                if (response && response.success) {
                    setCateNames(response.data.subcategory);
                    // setAuthorDetail(response.data.author);
                    setArticleDetail(response.data);
                }else{
                    if(response && response.authenticate === false){
                        await apiService.postRequest('/auth/logout');
                        localStorage.clear();
                        sessionStorage.clear();
                        window.location.href = '/login';
                    }
                }
            } catch (error) {
                console.error('Error fetching article data:', error);
            }finally{
                setLoading(false);
            }
        };

        fetchPreviewData();
    }, [id]);

    useEffect(() => {
        const fetchData = async () => {
            const response = await apiService.postRequest(`knowledge-article/owned-by-groups/${id}`);
            if (response && response.success) {
                setGroupId(response && response.roles);
                const selectedRole = response.roles.find(role => role.selected === true);
                if (selectedRole) {
                    setSelectedGroupId({ label: selectedRole.name, value: selectedRole.id });
                }
                const selectedUser = response.users.find(user => user.selected === true);
                if (selectedUser) {
                    setSelectedUserId({ label: selectedUser.name, value: selectedUser.id });
                }
                setFormData({
                    assignment_group_id: selectedRole && selectedRole.id,
                    assigned_to: selectedUser && selectedUser.id,
                    reason: '',
                })
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        };
        fetchData();
    }, [id]);
    useEffect(() => {
        if (formData.assignment_group_id) {
            const fetchData = async () => {
                const response = await apiService.postRequest(`knowledge-article/owned-by-groups/${id}?role_id=${formData.assignment_group_id}`);
                if (response.success) {
                    setUserId(response.users || []);
                }
                
            };
            fetchData();
        }
    }, [id, formData.assignment_group_id]);
    const handleInputChange = (e) => {
        const { name, value } = e.target;
    
        // Clear the error for the specific field being modified
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));

        setFormData({ ...formData, [name]: value });
    };
    const handleGroupChange = (selectedOption) => {
        setSelectedGroupId(selectedOption);
        handleInputChange({
            target: {
                name: 'assignment_group_id',
                value: selectedOption ? selectedOption.value : ''
            }
        });
        setSelectedUserId(null);
    };

    const handleUserIdChange = (selectedOption) => {
        setSelectedUserId(selectedOption);
        handleInputChange({
            target: {
                name: 'assigned_to',
                value: selectedOption ? selectedOption.value : ''
            }
        });
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.assignment_group_id) newErrors.assignment_group_id = "Assigned Group is required.";
        if (!formData.assigned_to) newErrors.assigned_to = "Assigned to is required.";
        if (!formData.reason) newErrors.reason = "Reason is required.";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const [submitloader,setSubmitloader] = useState(false)
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            setErrorMessage('Please fix the errors before proceeding.');
            return;
        }
        setSubmitloader(true);
        try {
    
            // Make the API request
            const response = await apiService.postRequest(`knowledge-article/assign-user/${id}`, formData);
    
            // Check response for success
            if (response.success) {
                setErrors({});
                setErrorMessage('');
                toast(response.message || "Assigned Successfully");
            } 
        } catch (error) {
            console.log(error,"Failed. Please try again");
        } finally {
            setSubmitloader(false); // Stop loader
        }
    };
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{ sm: 12 }} container className="main_jobseeker">
                <Grid size={{sm:12}} container alignItems="center" className="mario_fixers_article">
                    {articleDetail && articleDetail.status === "under_approval" ? (
                        <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                            <h3>Under Approval</h3>
                            <span>{catesNames.knowledge_base} <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {catesNames.category_name} <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {catesNames.name}</span>
                        </Grid>
                    ):""}
                    {articleDetail && articleDetail.status === "draft" ? (
                        <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                            <h3>Draft</h3>
                            <span>{catesNames.knowledge_base} <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {catesNames.category_name} <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {catesNames.name}</span>
                        </Grid>
                    ):""}
                    {articleDetail && articleDetail.status === "published" ? (
                        <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                            <h3>Published</h3>
                            <span>{catesNames.knowledge_base} <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {catesNames.category_name} <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {catesNames.name}</span>
                        </Grid>
                    ):""}
                    {articleDetail && articleDetail.status === "retired" ? (
                        <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                            <h3>Retired</h3>
                            <span>{catesNames.knowledge_base} <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {catesNames.category_name} <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {catesNames.name}</span>
                        </Grid>
                    ):""}
                </Grid>
                {loading ? (
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                    </div>
                ) : (<>
                <Grid size={{ xs: 12 }} container justifyContent="flex-start" className="statusselectbtn mt-4">
                    <div className='knowledgetab_btnredirect'>
                        <button className={currentPath.startsWith("/knowledge/edit-article") ? "active_tabbtn" : ""} onClick={() => navigate(`/knowledge/edit-article/${id}`)}>Article</button>
                        {articleDetail && articleDetail.status === "draft" ? <button className={currentPath.startsWith('/knowledge/assignments') ? "active_tabbtn" : ""} onClick={() =>{navigate(`/knowledge/assignments/${id}`)}}>Assignment</button>:
                        <button onClick={() => navigate(`/knowledge/under-approval/show/${id}`)}>Approvals</button>}
                        <button onClick={() => navigate(`/knowledge/history/${id}`)}>History</button>
                        <button className={currentPath.startsWith('/knowledge/attachments') ? "active_tabbtn" : ""} onClick={() => navigate(`/knowledge/attachments/${id}`)}>Attachments</button>
                        <button onClick={() =>{navigate(`/knowledge/discussions/${id}`)}}>Discussions</button>
                        <button onClick={() =>{navigate(`/knowledge/versions/${id}`)}}>Versions</button>
                    </div>
                </Grid>
                <form className='w-100' 
                    onSubmit={handleSubmit}
                >
                    <Grid size={{lg:12,xs:12}} container justifyContent="space-between" className="darfts_inputs for_textarespec mt-4">
                        <Grid size={{sm:5.8, xs:12}} container flexDirection="column">
                            <span>Assignment Group</span>
                            <Select
                                isDisabled={true}
                                className="basic-single select_withsearch"
                                classNamePrefix="select"
                                value={selectedGroupId}
                                defaultValue={null}
                                name="assignment_group_id"
                                options={groupId.map((state) => ({
                                    label: state.name,
                                    value: state.id,
                                }))}
                                onChange={handleGroupChange}
                            />
                            {errors.assignment_group_id && <p style={{color:"Red"}}>{errors.assignment_group_id}</p>}
                        </Grid>
                        <Grid size={{sm:5.8, xs:12}} container flexDirection="column">
                            <span>Assigned To</span>
                            <Select
                                // isDisabled={!showsave}
                                className="basic-single select_withsearch"
                                classNamePrefix="select"
                                value={selectedUserId}
                                defaultValue={null}
                                name="assigned_to"
                                options={userId.map((users) => ({
                                    label: users.name,
                                    value: users.id,
                                }))}
                                onChange={handleUserIdChange}
                            />
                            {errors.assigned_to && <p style={{color:"Red"}}>{errors.assigned_to}</p>}
                        </Grid>
                        <Grid size={{sm:12, xs:12}} container flexDirection="column">
                            <span>Reason for re-assignment</span>
                            <textarea placeholder='Write your reason' value={formData.reason} name='reason' onChange={handleInputChange} />
                            {errors.reason && <p style={{color:"Red"}}>{errors.reason}</p>}
                        </Grid>
                        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                        {/* {showsave &&  */}
                        <Grid size={{sm:12, xs:12}} container justifyContent="space-between" className="mt-2">
                            <button type='submit' className='registersendbtn2'>{submitloader ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Save'}</button>
                        </Grid>
                        {/* } */}
                    </Grid>
                </form>
                </>)}
            </Grid>
        </div>  
    </div>
  )
}

export default KbAssignments
